import { render, staticRenderFns } from "./Stok.vue?vue&type=template&id=09a251cd"
import script from "./Stok.vue?vue&type=script&lang=js"
export * from "./Stok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports